enum ROUTES {
  Home = '/',
  CheckEmail = '/check-email',
  Login = '/login',
  OldUrls = '/url-change-info',
  CreatePassword = '/create-password',
  PrivatePolicy = '/private-policy',
  ResetPassword = '/reset-password',
  NewPassword = '/new-password',
  PasswordModified = '/password-modified',
  Dashboard = '/dashboard',
  NotFoundPage = '/notfound',
  DeniedAccess = '/denied-access',
  TechnicalError = '/technical-error',
  MaintenanceError = '/maintenance-error',
  ModifyUserEmail = '/modify-user-email',
  EmailModified = '/email-modified',
  EmailModifiedFail = '/email-modified-fail',
  BillingSynthesis = '/billing-synthesis',
  BillingAnalyseEvolution = '/billing-analyse-evolution',
  Profile = '/profile',
  ProfileOrganization = '/my-perimeter',
  SessionExpired = '/session-expired',
  WasteRegister = '/waste-register',
  ActivitySynthesis = '/activity-synthesis',
  ActivityAdvancedReports = '/activity-synthesis/advanced-reports',
  ActivityAnalyseEvolution = '/activity-analyse-evolution',
  DocumentsManagement = '/documents-management',
  DocumentsBilling = '/billing-documents',
  DocumentsActivities = '/activity-documents',
  AttestationValorisation = '/activity-documents/attestation-valorisation',
  DocumentsOthers = '/other-documents',
  UserImpersonation = '/user-impersonation',
  AddDocumentClient = '/documents-management/add-document-client',
  AddDocumentInternal = '/documents-management/add-document-internal',
  ModifyDocumentClient = '/documents-management/modifiy-document-client/:id',
  ModifyDocumentInternal = '/documents-management/modifiy-document-internal/:id',
  ContactUs = '/contact-us',
  ContactSent = '/contact-sent',
  UserSignUp = '/sign-up',
  UserSignUpClient = '/sign-up-client',
  UserSignUpInfos = '/sign-up-infos',
  UserSignUpCreated = '/sign-up-user-created',
  MailPasswordSent = '/mail-password-sent',
  NotifSignUp = '/notif-sign-up',
  ExpandPerimeter = '/my-perimeter/expand-perimeter',
  // ExpandPerimeterMultiple = '/my-perimeter/expand-perimeter-multiple-contract', TODO : To reactivate or delete later. See : US 63903
  Administration = '/administration',
  UsersManagement = '/administration/users-management',
  CreateUserProfile = '/administration/users-management/create-user-profile',
  AttachmentContract = '/administration/users-management/attachment-contract',
  AttachmentContractDetail = '/administration/users-management/attachment-contract/:id',
  UserPerimeter = '/administration/users-management/user-perimeter',
  UserPerimeterDetail = '/administration/users-management/user-perimeter/:id',
  UpdateUserProfile = '/administration/users-management/modify-user-profile',
  UpdateUserProfileDetail = '/administration/users-management/modify-user-profile/:id',
  ModifyUserPerimeter = '/administration/users-management/modify-user-perimeter/',
  ModifyUserPerimeterDetail = '/administration/users-management/modify-user-perimeter/:idUser',
  UpdateUserAttachmentContract = '/administration/users-management/modify-user-contract',
  UpdateUserAttachmentContractDetail = '/administration/users-management/modify-user-contract/:id',
  OrganisationsManagement = '/administration/organisations-management',
  CreateOrganization = '/administration/organisations-management/create-organization',
  ModifyOrganization = '/administration/organisations-management/modify-organization',
  ModifyOrganizationDetail = '/administration/organisations-management/modify-organization/:idOrganization',
  MyDemands = '/my-demands',
  MySupportDemands = '/my-support-demands',
  DemandDetail = '/my-demands/details/:id',
  CreateDemand = '/my-demands/create-demand',
  MyServices = '/my-services',
  SuperAdmin = '/super-admin',
  SuperAdminKPI = '/super-admin/kpi',
  SuperAdminUsersManagement = '/super-admin/users-management',
  SuperAdminOrganisationsManagement = '/super-admin/organisations-management',
  SuperAdminCommunications = '/super-admin/communications',
  SuperAdminCommunicationsCreate = '/super-admin/communications/create',
  SuperAdminCommunicationsUpdate = '/super-admin/communications/update/:id',
  SuperAdminMessagesManagement = '/super-admin/MessagesManagement',
  SuperAdminCreateSideMessage = '/super-admin/MessagesManagement/CreateSideMessage',
  SuperAdminModifySideMessage = '/super-admin/MessagesManagement/modify-side-message',
  SuperAdminModifySideMessageDetail = '/super-admin/MessagesManagement/modify-side-message/:id',
  SuperAdminTechMaintenance = '/super-admin/maintenance',
  UploadRegister = '/upload-register',
  confirmMaintenance = '/confirm-maintenance',
  help = '/help',
  Notifications = '/notifications',
  Offres = '/offres',
}
// ROUTES accessible without a login
export const EXCLUDED_ROUTES: string[] = [
  ROUTES.CreatePassword,
  ROUTES.ResetPassword,
  ROUTES.NewPassword,
  ROUTES.PasswordModified,
  ROUTES.ContactSent,
  ROUTES.UserSignUpCreated,
  ROUTES.MailPasswordSent,
  ROUTES.OldUrls,
]

export const DASHBOARD_ROUTES: string[] = [
  ROUTES.Dashboard,
  ROUTES.CreateOrganization,
  ROUTES.ModifyOrganizationDetail,
  ROUTES.CreateUserProfile,
  ROUTES.UpdateUserProfileDetail,
  ROUTES.UpdateUserAttachmentContractDetail,
  ROUTES.UsersManagement,
  ROUTES.UserPerimeterDetail,
  ROUTES.Profile,
  ROUTES.BillingSynthesis,
  ROUTES.BillingAnalyseEvolution,
  ROUTES.AttachmentContractDetail,
  ROUTES.ProfileOrganization,
  ROUTES.OrganisationsManagement,
  ROUTES.WasteRegister,
  ROUTES.ActivitySynthesis,
  ROUTES.ActivityAdvancedReports,
  ROUTES.ActivityAnalyseEvolution,
  ROUTES.DocumentsManagement,
  ROUTES.DocumentsBilling,
  ROUTES.DocumentsActivities,
  ROUTES.DocumentsOthers,
  ROUTES.UserImpersonation,
  ROUTES.AddDocumentClient,
  ROUTES.AddDocumentInternal,
  ROUTES.ModifyDocumentClient,
  ROUTES.ModifyDocumentInternal,
  ROUTES.ContactUs,
  ROUTES.ExpandPerimeter,
  // ROUTES.ExpandPerimeterMultiple, TODO : To reactivate or delete later. See : US 63903
  ROUTES.Administration,
  ROUTES.MyDemands,
  ROUTES.MySupportDemands,
  ROUTES.DemandDetail,
  ROUTES.CreateDemand,
  ROUTES.ModifyUserPerimeterDetail,
  ROUTES.AttestationValorisation,
  ROUTES.MyServices,
  ROUTES.SuperAdmin,
  ROUTES.SuperAdminKPI,
  ROUTES.SuperAdminUsersManagement,
  ROUTES.SuperAdminOrganisationsManagement,
  ROUTES.SuperAdminCommunications,
  ROUTES.SuperAdminCommunicationsCreate,
  ROUTES.SuperAdminCommunicationsUpdate,
  ROUTES.SuperAdminMessagesManagement,
  ROUTES.SuperAdminCreateSideMessage,
  ROUTES.SuperAdminModifySideMessageDetail,
  ROUTES.help,
  ROUTES.Notifications,
  ROUTES.SuperAdminTechMaintenance,
  ROUTES.ModifyUserEmail,
  ROUTES.Offres,
]

export const CREATE_USER_ROUTES: string[] = [
  ROUTES.CreateUserProfile,
  ROUTES.UpdateUserProfile,
  ROUTES.UpdateUserAttachmentContract,
  ROUTES.AttachmentContract,
  ROUTES.AttachmentContractDetail,
  ROUTES.UserPerimeter,
  ROUTES.ModifyUserPerimeter,
  ROUTES.UserPerimeterDetail,
]

export const SIGNUP_USER_ROUTES: string[] = [
  ROUTES.UserSignUp,
  ROUTES.UserSignUpClient,
  ROUTES.UserSignUpInfos,
]

export const PATHS_WITHOUT_PERIMETER_FILTER: string[] = [
  ROUTES.ModifyOrganizationDetail,
  ROUTES.Profile,
  ROUTES.ProfileOrganization,
  ROUTES.ModifyDocumentClient,
  ROUTES.ModifyDocumentInternal,
  ROUTES.SuperAdminModifySideMessageDetail,
  ROUTES.MyServices,
  ...CREATE_USER_ROUTES,
  ...SIGNUP_USER_ROUTES,
  ROUTES.SuperAdminTechMaintenance,
]

// we filter in order to avoid repeat routes
export const WITH_PERIMETER_FILTER: string[] = DASHBOARD_ROUTES.filter(
  (pathname) => {
    return (
      !CREATE_USER_ROUTES.some((route) => pathname.includes(route)) &&
      !SIGNUP_USER_ROUTES.some((route) => pathname.includes(route)) &&
      ROUTES.ModifyUserPerimeter !== pathname &&
      ROUTES.Profile !== pathname &&
      ROUTES.ProfileOrganization !== pathname &&
      ROUTES.MyServices !== pathname &&
      ROUTES.ExpandPerimeter !== pathname &&
      // ROUTES.ExpandPerimeterMultiple !== pathname && TODO : To reactivate or delete later. See : US 63903
      ROUTES.ContactUs !== pathname &&
      ROUTES.SuperAdminTechMaintenance !== pathname
    )
  }
)

export default ROUTES
